import { TableMap } from '../table-map';
import { isSelectionType } from './is-selection-type';

// Checks if a given CellSelection rect is selected
export var isRectSelected = function isRectSelected(rect) {
  return function (selection) {
    if (!isSelectionType(selection, 'cell')) {
      return false;
    }
    var map = TableMap.get(selection.$anchorCell.node(-1));
    var start = selection.$anchorCell.start(-1);
    var cells = map.cellsInRect(rect);
    var selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
    for (var i = 0, count = cells.length; i < count; i++) {
      if (selectedCells.indexOf(cells[i]) === -1) {
        return false;
      }
    }
    return true;
  };
};

// Checks if entire column at index `columnIndex` is selected.
export var isColumnSelected = function isColumnSelected(columnIndex) {
  return function (selection) {
    if (isSelectionType(selection, 'cell')) {
      var map = TableMap.get(selection.$anchorCell.node(-1));
      return isRectSelected({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
      })(selection);
    }
    return false;
  };
};

// Checks if entire row at index `rowIndex` is selected.
export var isRowSelected = function isRowSelected(rowIndex) {
  return function (selection) {
    if (isSelectionType(selection, 'cell')) {
      var map = TableMap.get(selection.$anchorCell.node(-1));
      return isRectSelected({
        left: 0,
        right: map.width,
        top: rowIndex,
        bottom: rowIndex + 1
      })(selection);
    }
    return false;
  };
};

// Checks if entire table is selected
export var isTableSelected = function isTableSelected(selection) {
  if (isSelectionType(selection, 'cell')) {
    var map = TableMap.get(selection.$anchorCell.node(-1));
    return isRectSelected({
      left: 0,
      right: map.width,
      top: 0,
      bottom: map.height
    })(selection);
  }
  return false;
};